"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recommendation = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _offerStyles = require("../loan-card-v3/offer-styles");

var _baseReactComponents = require("@navinc/base-react-components");

var _common = require("./common");

var _jsxRuntime = require("react/jsx-runtime");

var RecommendationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "RecommendationWrapper",
  componentId: "sc-1wfd8b-0"
})(["&&{> *{margin:12px 0;}}"]);

var Recommendation = function Recommendation(_ref) {
  var recommendation = _ref.recommendation;

  if (!recommendation) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RecommendationWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.WithIconWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "feedback/thumbs-up",
        color: _baseReactComponents.theme.mermaidGreen500
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.PreLineCopy, {
        children: recommendation
      })]
    })
  });
};

exports.Recommendation = Recommendation;
//# sourceMappingURL=recommendation.js.map